export var CategoryType;
(function (CategoryType) {
    CategoryType["NEWS"] = "news";
    CategoryType["PRODUCT"] = "product";
    CategoryType["BOTH"] = "both";
    CategoryType["GALLERY"] = "gallery";
})(CategoryType || (CategoryType = {}));
//# sourceMappingURL=category.type.js.map